import {
  FileArchive,
  FileAudio,
  FileCode,
  FileImage,
  FileSpreadsheet,
  FileText,
  FileVideo,
  FolderOpenDot,
} from 'lucide-react'

const getIconFromExtension = (ext: string, url?: string | null) => {
  const normalizedExt = ext.toLowerCase()
  if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp', 'tiff'].includes(normalizedExt)) {
    if (url) return <img loading='lazy' decoding='async' src={url} alt='Preview' className='h-6 w-6 object-cover' />
    else return <FileImage className='text-green-500' />
  }
  if (['mp4', 'avi', 'mov', 'wmv', 'flv', 'webm', 'mkv'].includes(normalizedExt))
    return <FileVideo className='text-purple-500' />
  if (['mp3', 'wav', 'flac', 'aac', 'ogg', 'wma'].includes(normalizedExt))
    return <FileAudio className='text-orange-500' />
  if (['pdf', 'doc', 'docx'].includes(normalizedExt)) return <FolderOpenDot className='text-blue-500' />
  if (['xls', 'xlsx'].includes(normalizedExt)) return <FileSpreadsheet className='text-green-600' />
  if (['ppt', 'pptx'].includes(normalizedExt)) return <FileSpreadsheet className='text-orange-600' />
  if (['zip', 'rar', '7z', 'gz'].includes(normalizedExt)) return <FileArchive className='text-yellow-500' />
  if (['txt', 'html', 'css', 'js', 'json', 'xml', 'ts', 'tsx', 'py', 'java', 'cpp', 'c'].includes(normalizedExt))
    return <FileCode className='text-black-600' />

  return <FileText className='text-gray-500' />
}

export const getFileIconFromUrl = (url?: string | null) => {
  if (!url) return FileText
  try {
    const parsed = new URL(url)
    // Get last segment of path, e.g., file.docx
    const filename = parsed.pathname.split('/').pop() || ''
    // Remove potential query or fragments from filename
    const ext = filename.split('.').pop()?.split('?')[0]?.split('#')[0]?.toLowerCase() || ''
    return getIconFromExtension(ext, url)
  } catch {
    // fallback: try to extract from string (ignore query params)
    const cleanUrl = url.split('?')[0].split('#')[0]
    const fallbackExt = cleanUrl.split('.').pop()?.toLowerCase() || ''
    return getIconFromExtension(fallbackExt)
  }
}
